import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource } from '@atlassian/react-resource-router';
import type { TransitioningDetailsResponse } from './types.tsx';

export const getTransitioningDetails = (cloudId: string) =>
	performGetRequest<TransitioningDetailsResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`,
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getTransitioningDetails',
				packageName: 'jiraRouterResourcesEocUnlockOperations',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});

export const transitioningDetailsResource = createResource({
	type: 'EOC_UNLOCK_OPERATIONS',
	getKey: () => 'eoc-unlock-operations',
	getData: async (_, { tenantContext: { cloudId } }) => getTransitioningDetails(cloudId),
	maxAge: 0,
	isBrowserOnly: true,
});
